// This module is used for access to ENV variables during runtime
export default {
  MOBX_LOG_ENABLED: MOBX_LOG_ENABLED,
  CLIENT_ID: CLIENT_ID,
  NETBOX_CLIENT_ID: NETBOX_CLIENT_ID,
  IS_DEV: IS_DEV,
  PLAYER_JS_URL: '',
  PLAYER_CSS_URL: '',
  APP_VERSION: APP_VERSION,
  API_HOST: API_HOST,
  CARBON_VIEWER_BRANCH: CARBON_VIEWER_BRANCH,
  CARBON_VIEWER_CDN_URL: CARBON_VIEWER_CDN_URL,
  SHORT_LINKS_BASE_URL: SHORT_LINKS_BASE_URL,
  COLLAGE_IMAGES_BASE_URL: COLLAGE_IMAGES_BASE_URL,
  RING_TRY_ON_RESOURCES_HOST: RING_TRY_ON_RESOURCES_HOST,
  RING_TRY_ON_URL: RING_TRY_ON_URL,
  OPENREPLAY_URL: OPENREPLAY_URL,
  OPENREPLAY_KEY: OPENREPLAY_KEY,
};
